<template>
  <nav class="navbar sticky-top navbar-expand navbar-dark bg-dark">
    <a class="d-lg-none btn nav-link" @click.prevent="toggleSidebar">
      <font-awesome-icon :icon="sidebarIsCollapsed ? 'bars' : 'times'" fixed-width size="lg" />
    </a>

    <div class="col">
      <a href="/" class="active"
        ><img
          src="/trustmark_logo_light_2023.svg"
          class="img img-fluid"
          style="height: 32px; margin: 7px 26px"
      /></a>
    </div>

    <div class="navbar-nav mr-auto">
      <li class="d-none d-md-block nav-item text-nowrap">
        <span to="/profile" class="nav-link">
          <font-awesome-icon icon="user" />
          {{ currentAccount.accountName }}
        </span>
      </li>
      <li class="nav-item text-nowrap">
        <router-link to="/comms-link" class="nav-link" target="_blank" rel="noopener noreferrer">
          <popover content="Comms Platform" placement="left" :hideinfo="true">
            <div
              class="rounded-pill badge bg-danger"
              style="display: inline-block; margin-top: 1px"
            >
              {{ unreadMessageCount }}
              <span class="visually-hidden">unread messages</span>
            </div>
          </popover>
        </router-link>
      </li>
      <li class="nav-item text-nowrap">
        <a class="btn nav-link" @click.prevent="logOut">
          <font-awesome-icon icon="right-from-bracket" class="me-1" /> Log out
        </a>
      </li>
    </div>
  </nav>
</template>

<script>
import logoutCleanup from '../services/logout-cleanup';
import Popover from './Popover.vue';

export default {
  name: 'SchemeNavBar',
  components: {
    Popover,
  },
  computed: {
    unreadMessageCount() {
      return this.$store.state.comms.unreadMessageCount;
    },
    currentAccount() {
      return this.$store.state.auth.account;
    },
    sidebarIsCollapsed() {
      return this.$store.state.sidebarIsCollapsed;
    },
    hasBackOfficePortalAccess() {
      if (this.currentAccount && this.currentAccount.roles) {
        return this.currentAccount.roles.includes('BackOfficePortalAccess');
      }
      return false;
    },
  },
  methods: {
    logOut() {
      this.$store.commit('setIsBusy', true, { root: true });
      logoutCleanup();
    },
    toggleSidebar() {
      this.$store.commit('setSidebarCollapsed', !this.sidebarIsCollapsed);
    },
  },
};
</script>

<style scoped>
.nav-link {
  color: white !important;
}

.nav-item {
  padding-left: 10px;
  padding-right: 10px;
}
</style>
